import { BannerAnalyticsPayload } from "../app/slice/bannerSlice";
import { GET_FLOW_BUILDER_BANNERS, getSubscriptionDetailsResponseBody, GET_SUBSCRIBER, UpdateOrDeleteResponseBody, updateSubscriptionResponseBody, API_ANALYTIC_URL, GET_BANNER_ANALYTICS, getSupportChatJwtResponseBody, GET_SUPPORT_CHAT_JWT, SEND_MESSAGE, sendMessageResponseBody } from "../utils/constant";
import { getJson, postJson, putJson } from "../utils/network";

export async function getFlowBuilderBanner() {
  const { response } = await getJson<UpdateOrDeleteResponseBody>(GET_FLOW_BUILDER_BANNERS);

  return response;
}


async function sendBannerAnalytics(payload: BannerAnalyticsPayload, store: string) {
  const token = btoa(JSON.stringify(payload));
  const url = GET_BANNER_ANALYTICS(store);

  const { response } = await postJson<UpdateOrDeleteResponseBody>(url, { token }, API_ANALYTIC_URL);

  return response;
}

export async function countAdminBannerClick(payload: BannerAnalyticsPayload, store: string) {
  return sendBannerAnalytics(payload, store);
}

export async function countAdminBannerImp(payload: BannerAnalyticsPayload, store: string) {
  return sendBannerAnalytics(payload, store);
}

export const updateSubscription = async (data: any) => {
  const { response } = await putJson<updateSubscriptionResponseBody>(GET_SUBSCRIBER, data);

  return response;
};

export const getSubscriptionDetails = async (data: any) => {
  const { response } = await getJson<getSubscriptionDetailsResponseBody>(GET_SUBSCRIBER, data);

  return response;
};

export const sendMessage = async (data: any) => {
  const { response } =
    await postJson<sendMessageResponseBody>(
      SEND_MESSAGE,
      data
    );

  return response;
};

export const getSupportChatJwt = async () => {
  const { response } =
    await postJson<getSupportChatJwtResponseBody>(
      GET_SUPPORT_CHAT_JWT,
      {}
    );

  return response;
};
